import React from "react";
import styles from "./SubmitButton.module.css";

interface SubmitButtonProps {
  text: string;
  disabled?: boolean;
  loading?: boolean;
  onClick?: () => void;
}

const SubmitButton: React.FC<SubmitButtonProps> = ({
  text,
  disabled = false,
  loading = false,
  onClick,
}) => {
  return (
    <button
      type="submit"
      disabled={disabled || loading}
      onClick={onClick}
      className={`${styles.button} ${
        disabled || loading ? styles.buttonDisabled : styles.buttonEnabled
      }`}
    >
      {loading ? (
        <span className={styles.spinner}>
          <span className={styles.spinnerInner}></span>
        </span>
      ) : null}
      <span className={loading ? styles.loadingText : ""}>{text}</span>
    </button>
  );
};

export default SubmitButton;
